// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../AppData/Roaming/nvm/v12.22.12/node_modules/expo-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-confirm-alert-body {\r\n    width: 200px;\r\n  }", ""]);
// Exports
module.exports = exports;
